import React, { useEffect, useState } from "react";
import { ResponsiveRadar } from "@nivo/radar";
import { Spin } from "antd";
import ApiService from "../../Components/apiService.js";
import { BASE_URL } from "../../Components/Constant";

const Radar = ({ reportId }) => {
    const [radarData, setRadarData] = useState([]);
    const [keys, setKeys] = useState([]);
    const [indexBy, setIndexBy] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!reportId) return;

        const apiServiceForRecords = new ApiService(
            `${BASE_URL}/mt_reports/${reportId}`,
            { "Content-Type": "application/json" },
            "GET"
        );

        apiServiceForRecords
            .makeCall()
            .then((response) => {

                if (response.report && response.data.length > 0) {
                    const aggregationFields = response.report.aggregation_fields || ["AnnualRevenue"];
                    const groupField = response.report.group_fields?.[0] || "Name";

                    const formattedData = response.data.map((record) => {
                        let obj = { [groupField]: record[groupField] || "Unknown" };
                        aggregationFields.forEach(field => {
                            obj[field] = record[field] || 0;
                        });
                        return obj;
                    });

                    setRadarData(formattedData);
                    setKeys(aggregationFields);
                    setIndexBy(groupField);
                } else {
                    setRadarData([]);
                }
                setLoading(false);
            })
            .catch((err) => {
                setError(err);
                setLoading(false);
            });
    }, [reportId]);

    if (!reportId) return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: 'orange', fontStyle: 'bold' }}>
            Report not attached correctly.
        </div>
    );
    if (loading) return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Spin size="large" />
        </div>
    );
    if (error) return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: 'red', fontStyle: 'bold' }}>
            Error: {error.message || error.error}
        </div>
    );

    return (
        <ResponsiveRadar
            data={radarData}
            keys={keys}
            indexBy={indexBy}
            maxValue="auto"
            margin={{ top: 70, right: 80, bottom: 40, left: 80 }}
            curve="linearClosed"
            borderWidth={2}
            borderColor="inherit"
            gridLevels={5}
            gridShape="circular"
            gridLabelOffset={36}
            enableDots={true}
            dotSize={8}
            dotColor="inherit"
            dotBorderWidth={0}
            dotBorderColor="#ffffff"
            enableDotLabel={true}
            dotLabel="value"
            dotLabelYOffset={-12}
            colors={{ scheme: "nivo" }}
            fillOpacity={0.1}
            animate={true}
            motionStiffness={90}
            motionDamping={15}
            isInteractive={true}
            legends={[
                {
                    anchor: "top-left",
                    direction: "column",
                    translateX: -50,
                    translateY: -40,
                    itemWidth: 80,
                    itemHeight: 20,
                    itemTextColor: "#999",
                    symbolSize: 12,
                    symbolShape: "circle",
                    effects: [{ on: "hover", style: { itemTextColor: "#000" } }]
                }
            ]}
        />
    );
};

export default Radar;